import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=1d6c9fa5"
import script from "./order-detail.js?vue&type=script&lang=js&external"
export * from "./order-detail.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports